import { OrganizersApplicationDto } from '~/modules/Organizers/Application/GetAllOrganizers/OrganizersApplicationDto'
import { OrganizerFilterComponentDto } from '~/modules/Organizers/Infrastructure/OrganizerFilterComponentDto'

export class OrganizerFilterComponentDtoTranslator {
  public static fromOrganizerApplicationDto (dto: OrganizersApplicationDto): OrganizerFilterComponentDto {
    return {
      id: dto.id,
      name: dto.name,
    }
  }
}
